<template>
  <div class="left-title">
    {{name}}
    <div class="right-link">
      <slot name="rightLink"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    name: {
      type: String,
      default: '规则目录'
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.left-title {
  font-size: 20px;
  color: #333;
  font-weight: 500;
  line-height: 28px;
  padding-top: 20px;
  padding-bottom: 20px;
  .right-link {
    float: right;
    font-size: 14px;
    color: #666;
    font-weight: 400;
    margin-right: 30px;
    :deep(a)  {
      color: #666;
    }
  }
}
</style>
